import * as AbsintheSocket from '@absinthe/socket'
import * as Phoenix from 'phoenix';
import { parseGraphQLMethodFromQuery } from './GraphQLUtils';

export class GraphQLClientSocket {

  notifiers = {};

  initialize = ({ url, token }) => {
    this.url = url;
    this.token = token;
    this.absintheSocket = AbsintheSocket.create(
      new Phoenix.Socket(this.url, {
        params: {
          token: this.token
        }
      })
    );
  };

  subscribe = (params) => {
    const { query, variables, onAbort, onStart, onResult } = params;
    const subscriptionName = parseGraphQLMethodFromQuery(query);

    if (this.notifiers[subscriptionName]) {
      this.unsubscribe(subscriptionName);
    }
    const notifier = AbsintheSocket.send(this.absintheSocket, { operation: query, variables });
    AbsintheSocket.observe(this.absintheSocket, notifier, {
      onStart: onStart || function () {},
      onAbort: onAbort || function () {},
      onResult: onResult || function () {},
    });
    this.notifiers[subscriptionName] = notifier;
  };

  unsubscribe = (query) => {
    const subscriptionName = parseGraphQLMethodFromQuery(query);
    if (this.notifiers[subscriptionName]) {
      AbsintheSocket.cancel(this.absintheSocket, this.notifiers[subscriptionName]);
      delete this.notifiers[subscriptionName];
    }
  };

  destroy = () => {
    for (let subscriptionName in this.notifiers) {
      AbsintheSocket.cancel(this.absintheSocket, this.notifiers[subscriptionName]);
      delete this.notifiers[subscriptionName];
    }
    this.url = null;
    this.token = null;
    this.absintheSocket = null;
  };
}
